import  React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ReactPlayer from 'react-player'
import promoVideo from '../imgs/PromoVideo.mp4'
import { useTranslation } from "react-i18next";


export default function Hero() {
    const navigate = useNavigate()
    const [t,i18n] = useTranslation("global");
    const [showModal, setShowModal] = useState(false);
    const [playing, setPlaying] = useState(true);
    const handleSubmit = (e) => {
        e.preventDefault()
        navigate('/calculadora-de-salarios/datos',{state:{sueldo:0,dependientes:0,ingresosCotizables:0,ingresosNoCotizables:0}})
        console.log("Your languange is set to:",i18n.language)
        // localStorage.clear()
    }
 
  return (
        
      <div className="block lg:flex lg:pt-10 text-black font-dmSans ">
          {/* Left Side */}
         
        <div className="block lg:w-[40%] p-4 lg:p-8 lg:p-0 lg:ml-20 2xl:ml-40 5xl:ml-80">
            <img src={require("../imgs/Title-Decor-1.png")} className="hidden lg:block float-right pr-2 5xl:pr-60" alt="" />
            <div className="pb-4"></div>
            <h1 className="font-bold text-5xl lg:text-6xl 2xl:text-8xl lg:leading-[75px] text-left">{t("hero.title")}
            </h1>
            <img src={require("../imgs/Title-Line.png")} alt="" className="4xl:w-[75%] 5xl:w-[60%]"/>
            <p className="text-left mt-14 text-lg leading-[34px] 5xl:text-2xl">
            {t("hero.desc")}
            </p>
            {/* buttons */}
            <div className="flex pt-6">
                <button className="5xl:text-xl mx-20 lg:mx-0 font-bold px-20 py-5 rounded-[12px] text-white bg-[#4856DF] mr-2 hover:bg-[#485FFF] mr-10 hover:shadow-lg" onClick={(e)=>{handleSubmit(e)}}>{t("hero.calc-button")}</button>
                <button className="5xl:text-xl hidden lg:block font-bold bg-white rounded-full shadow-lg min-w-[65px] border-4 border-l-[#FFBE21] hover:border-[#FFBE21] ml-4" onClick={()=>{setShowModal(true)}}><svg className="inline-flex self-center pl-[5.5px]" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="black" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="5 3 19 12 5 21 5 3"></polygon></svg></button>
                <p  className="5xl:text-xl font-bold pl-2 self-center cursor-pointer hidden lg:flex" onClick={()=>{setShowModal(true)}}>{t("hero.vid-button")}  {showModal ? (
        
          <div tabIndex={0} onBlur={(e)=>{e.preventDefault;setShowModal(false);setPlaying(false);}} className="flex justify-center items-center overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-3xl">
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-transparent outline-none focus:outline-none">
                    <button onClick={(e) => {setShowModal(false);  e.target.style.visibility = 'hidden';}} className='flex justify-end w-fit ml-auto bg-gray-500 rounded-full px-4 py-2 mb-2 font-bold text-2xl text-red-500 hover:opacity-75'>
        x
      </button>
              <ReactPlayer
              controls
              playing={playing}
                 url={[
                  {src: promoVideo, type: 'video/mp4'},
                  
                    ]}
                />

              </div>
            </div>
          </div>
        
      ) : null}</p>
            </div>
        </div>
        {/* Right Side */}
        <div>
        <div className="flex ">
            <div className="backgroundHero1">
            <img src={require("../imgs/HeroBG.png")} alt="" className="relative self-end mt-12 w-[80%] lg:block xl:block hidden"/>
            </div>
        </div>
        </div>

      </div>
   
  );
}